import { useEffect, useRef, RefObject } from "react";

/**
 * Returns a ref to attach to a numeric input element.
 * Prevents the mouse wheel from changing the input value
 * by calling preventDefault on the wheel event.
 */
export function useDisableWheel<
    T extends HTMLElement = HTMLInputElement
>(): RefObject<T> {
    const ref = useRef<T | null>(null);

    useEffect(() => {
        const el = ref.current;
        const handleWheel = (e: Event) => e.preventDefault();

        el?.addEventListener("wheel", handleWheel, { passive: false });

        return () => {
            el?.removeEventListener("wheel", handleWheel);
        };
    }, []);

    return ref;
}
